import React, { FC } from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';

import { IAdminGroup } from '../../../../../../store/admin/groups/store';

import AccordionCard from '../../../../../../components/GroupInvitationAccordion/GroupInvitationAccordion';

interface IProps {
  eventId?: number;
  selectedGroups: { [key: number]: boolean };
  groupSetup: (tag: IAdminGroup) => any;
  groups: IAdminGroup[];
}

const GroupInvitations: FC<IProps> = props => {
  const { selectedGroups, groups, groupSetup } = props;

  return (
    <AccordionCard
      className="accordion-card"
      title="ADD PLAYER GROUPS"
      sectionKey="INVITE_PLAYERS.ADD_PLAYERS_GROUPS"
    >
      <p>Select tagged groups from your player roster:</p>

      {groups.map((tag: IAdminGroup) => (
        <div className="tags-cb" key={`tag-${tag.id}`}>
          <FormControlLabel
            color="primary"
            control={
              <Checkbox
                className="group-invitations-checkbox"
                onChange={groupSetup(tag)}
                checked={!!selectedGroups[tag.id]}
                color="primary"
              />
            }
            label={tag.name}
          />
        </div>
      ))}
    </AccordionCard>
  );
};

export default GroupInvitations;
